import React from 'react';
import { withRouter } from 'react-router-dom';

import Suspense from '../../Common/components/Suspense-component';
import localStorage from '../../Common/LocalStorage';
import EditUser from '../component-edit-user';

import { UserRole } from '../../Common/UserRole';
import { getCompanyOfUser, getPharmacyOfUser, getSingleUser, getUserStatus } from '../epics-users';
import { getCompaniesList, getPharmaciesForSingleCompany, getCompaniesListForOwner } from '../../Companies/epics-companies';
import { getPharmacyListForManager } from '../../Pharmacies/epics-pharmacies';

class EditUserContainer extends React.Component {
    generateDeppendsOnRole = (role, specificRole, generalList, specificList) => {
        switch (role) {
            case specificRole:
                return specificList;
            case '':
                return [];
            default:
                return generalList;
        }
    };

    generateUserDetails = () => {
        const url = this.props.location.pathname;
        let companyId = url.split('/').pop();
        return getSingleUser(companyId);
    };

    generateCompanyList = (id, userRole) => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                return typeof userRole !== 'undefined'
                    ? this.generateDeppendsOnRole(userRole, UserRole.STORE_OWNER, getCompaniesList(), getCompaniesListForOwner(id))
                    : [];
            case UserRole.STORE_OWNER:
                return getCompanyOfUser();
            case UserRole.PHARMACY_MANAGER:
                return getCompanyOfUser();
            default:
                return [];
        }
    };

    generatePharmacyList = (userId, companyId, userRole) => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                if (companyId !== '') {
                    return typeof userRole !== 'undefined'
                        ? this.generateDeppendsOnRole(
                              userRole,
                              UserRole.PHARMACY_MANAGER,
                              getPharmaciesForSingleCompany(companyId),
                              getPharmacyListForManager(userId, companyId)
                          )
                        : [];
                } else {
                    return [];
                }
            case UserRole.STORE_OWNER:
                return companyId ? getPharmaciesForSingleCompany(companyId) : [];
            case UserRole.PHARMACY_MANAGER:
                return getPharmacyOfUser();
            default:
                return [];
        }
    };

    render() {
        return (
            <Suspense
                apiCalls={{
                    status: getUserStatus,
                    userDetails: this.generateUserDetails,
                    companyList: (id, userRole) => this.generateCompanyList(id, userRole),
                    pharmacyList: (userId, companyId, userRole) => this.generatePharmacyList(userId, companyId, userRole)
                }}
            >
                <EditUser />
            </Suspense>
        );
    }
}

export default withRouter(EditUserContainer);



// WEBPACK FOOTER //
// ./src/customModules/Users/containers/container-edit-user.js